import historyProvider from './history-provider';
import stream from './stream';

let currentBrokerValue: number = 3; 

export function setBrokerValue(broker: number) {
  currentBrokerValue = broker;
}

const supportedResolutions = [
  '1',
  '3',
  '5',
  '15',
  '30',
  '45',
  '60',
  '120',
  '180',
  '240',
  '480',
  'D',
];
const config = {
  supported_resolutions: supportedResolutions,
};

// Store polling intervals per subscriber
const pollingIntervals: { [key: string]: NodeJS.Timeout } = {};

export default {
  onReady: (cb: any) => {
    setTimeout(() => cb(config), 0);
  },

  searchSymbols: (
    userInput: any,
    exchange: any,
    symbolType: any,
    onResultReadyCallback: any
  ) => {},

  resolveSymbol: (
    symbolName: any,
    onSymbolResolvedCallback: any,
    onResolveErrorCallback: any
  ) => {
    const symbol_stub = {
      name: symbolName,
      description: '',
      type: 'Stocks',
      session: '24x7',
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      ticker: symbolName,
      exchange: 'NSE',
      minmov: 1,
      minmov2: 0,
      pointvalue: 1,
      pricescale: 100,
      has_intraday: true,
      intraday_multipliers: ['1', '60'],
      supported_resolution: supportedResolutions,
      volume_precision: 8,
      data_status: 'streaming',
    };
    setTimeout(() => {
      onSymbolResolvedCallback(symbol_stub);
    }, 0);
  },

  getBars: function (
    symbolInfo: any,
    resolution: any,
    from: any,
    to: any,
    onHistoryCallback: any,
    onErrorCallback: any,
    firstDataRequest: any
  ) {
    historyProvider
      .getBars(
        symbolInfo,
        resolution,
        from,
        to,
        firstDataRequest,
        2000,
        currentBrokerValue
      )
      .then((bars) => {
        onHistoryCallback(bars, { noData: !bars.length });
      })
      .catch((err) => {
        onErrorCallback(err);
      });
  },

  subscribeBars: function (
    symbolInfo: any,
    resolution: any,
    onRealtimeCallback: any,
    subscribeUID: any,
    onResetCacheNeededCallback: any
  ) {
    stream.subscribeBars(
      symbolInfo,
      resolution,
      onRealtimeCallback,
      subscribeUID,
      onResetCacheNeededCallback
    );

    // Start polling every 10 seconds to call getBars
    const interval = setInterval(() => {
      const now = Math.floor(Date.now() / 1000);
      const tenMinutesAgo = now - 600;

      historyProvider
        .getBars(symbolInfo, resolution, tenMinutesAgo, now, true, 2000, currentBrokerValue )
        .then((bars) => {
          if (bars.length) {
            const lastBar = bars[bars.length - 1];
            onRealtimeCallback(lastBar);
          }
        })
        .catch((err) => {
          console.error('Polling getBars error:', err);
        });
    }, 2000);

    pollingIntervals[subscribeUID] = interval;
  },

  unsubscribeBars: (subscriberUID: any) => {
    stream.unsubscribeBars(subscriberUID);
    if (pollingIntervals[subscriberUID]) {
      clearInterval(pollingIntervals[subscriberUID]);
      delete pollingIntervals[subscriberUID];
    }
  },
  calculateHistoryDepth: (
    resolution: any,
    resolutionBack: any,
    intervalBack: any
  ) => {
    return resolution < 60
      ? { resolutionBack: 'D', intervalBack: '1' }
      : undefined;
  },

  getMarks: () => {},
  getTimeScaleMarks: () => {},
  getServerTime: () => {},
};
